var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    { staticClass: "user" },
    [
      _c(
        "el-menu",
        { attrs: { mode: "horizontal" }, on: { open: _vm.open } },
        [
          _c(
            "el-submenu",
            {
              staticClass: "login-user",
              attrs: { index: "6", "popper-class": "login-user" }
            },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "user-icon" }, [
                  _c("div", { staticClass: "el-icon-user-solid" })
                ])
              ]),
              _c(
                "el-menu-item-group",
                { attrs: { title: _vm.loginUserName } },
                [
                  _c("el-menu-item", { on: { click: _vm.editUser } }, [
                    _vm._v("ユーザー情報")
                  ]),
                  _c("el-menu-item", { on: { click: _vm.changePassword } }, [
                    _vm._v("パスワード変更")
                  ]),
                  _c("el-menu-item", { on: { click: _vm.logOff } }, [
                    _vm._v("ログアウト")
                  ])
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c("UserMasterEditDialog", {
        attrs: {
          visible: _vm.editDialogVisible,
          "current-row": _vm.currentRow,
          programName: "UserInformation"
        },
        on: {
          "update:visible": function($event) {
            _vm.editDialogVisible = $event
          }
        }
      }),
      _c("UserMasterChangePasswordDialog", {
        attrs: {
          "current-row": _vm.currentRow,
          visible: _vm.changePasswordDialogVisible
        },
        on: {
          "update:visible": function($event) {
            _vm.changePasswordDialogVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }